import script from "./CounterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CounterSection.vue?vue&type=script&setup=true&lang=js"

import "./CounterSection.vue?vue&type=style&index=0&id=2f0cbf52&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0cbf52"]])

export default __exports__